/* eslint-disable no-undef */
import axios from 'axios';
import * as types from '../constantes/clientsProjects';

export const CreateClientsProjectsAction = (name, company, cnpj) => async (dispatch, getState) => {
  dispatch({
    type: types.CREATE_CLIENTS_PROJECTS_REQUEST,
    payload: { name, company, cnpj },
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/client-and-project/add`,
      {
        name,
        company,
        cnpj,
      },
      { headers: { Authorization: `bearer ${userInfo.token}` } },
    );
    dispatch({
      type: types.CREATE_CLIENTS_PROJECTS_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.CREATE_CLIENTS_PROJECTS_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const SearchClientsProjectsAction = () => async (dispatch, getState) => {
  dispatch({
    type: types.SEARCH_CLIENTS_PROJECTS_REQUEST,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/client-and-project`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.SEARCH_CLIENTS_PROJECTS_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_CLIENTS_PROJECTS_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const SearchSpecifyClientsProjectsAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: types.SEARCH_SPECIFY_CLIENTS_PROJECTS_REQUEST,
    payload: id,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/client-and-project/${id}`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.SEARCH_SPECIFY_CLIENTS_PROJECTS_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_SPECIFY_CLIENTS_PROJECTS_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const UpdateClientsProjectsAction = (id, name, company, cnpj, isActive) => async (dispatch, getState) => {
  dispatch({
    type: types.UPDATE_CLIENTS_PROJECTS_REQUEST,
    payload: { id, name, company, cnpj, isActive },
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();
    const { data } = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/client-and-project/${id}`,
      {
        id,
        name,
        company,
        cnpj,
        isActive,
      },
      { headers: { Authorization: `bearer ${userInfo.token}` } },
    );
    dispatch({
      type: types.UPDATE_CLIENTS_PROJECTS_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.UPDATE_CLIENTS_PROJECTS_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};
